import { Box, Button, Paper, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import { useLoaderData } from "react-router-dom";
import { Result } from "../../types/Result";
import SectionPanel from "../examSection/SectionPanel";
import { Exam } from "./type";

export default function ExamPanel() {
  const data = useLoaderData() as Result<Exam>;
  const exam = data.data!;
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const [showAnswers, setShowAnswers] = useState(false);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentSectionIndex(newValue);
  };

  const toggleShowAnswers = () => {
    setShowAnswers(!showAnswers);
  };

  return (
    <Box sx={{ width: "100%", p: 3 }}>
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          {exam.year} {exam.examType.name} Sınavı
        </Typography>
        <Typography variant="subtitle1">
          Tüm sorular ve cevapları bu panelde görüntülenebilir.
        </Typography>
        <Button
          variant="contained"
          color={showAnswers ? "secondary" : "primary"}
          onClick={toggleShowAnswers}
          sx={{ mt: 2 }}
        >
          {showAnswers ? "Cevapları Gizle" : "Cevapları Göster"}
        </Button>
      </Paper>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={currentSectionIndex} onChange={handleTabChange}>
          {exam.sections.map((section, index) => (
            <Tab key={index} label={section.examSectionType.examSectionName} />
          ))}
        </Tabs>
      </Box>

      <Box sx={{ mt: 3 }}>
        {exam.sections[currentSectionIndex] && (
          <SectionPanel
            section={exam.sections[currentSectionIndex]}
            showAnswers={showAnswers}
          />
        )}
      </Box>
    </Box>
  );
}
